import { render } from "./AppLoader.vue?vue&type=template&id=78e4d614"
import script from "./AppLoader.vue?vue&type=script&lang=js"
export * from "./AppLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__